import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';

interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  breadcrumb: string;
  actions?: ReactNode;
}

export default function PageHeader({ eyebrow, title, subtitle, breadcrumb, actions }: PageHeaderProps) {
  return (
    <section className="relative pt-28 md:pt-36 pb-12 md:pb-16 bg-background-100 border-b border-background-200 overflow-hidden">
      <div
        className="absolute -right-20 -top-20 w-72 h-72 rounded-full bg-accent-200/40 blur-3xl"
        aria-hidden="true"
      ></div>
      <div className="relative w-full px-4 md:px-8">
        <div className="max-w-shell mx-auto">
          <nav className="flex items-center gap-2 text-xs md:text-sm text-foreground-500" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-600 transition-colors">
              Home
            </Link>
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
            <span className="text-foreground-800 font-medium">{breadcrumb}</span>
          </nav>

          {eyebrow ? (
            <span className="mt-6 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3.5 py-1.5 text-[11px] font-semibold uppercase tracking-[0.16em] text-accent-900">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-500" aria-hidden="true"></span>
              {eyebrow}
            </span>
          ) : null}

          <h1 className="mt-4 font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 max-w-3xl text-balance">
            {title}
          </h1>
          {subtitle ? (
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600 max-w-2xl">{subtitle}</p>
          ) : null}
          {actions ? <div className="mt-6 md:mt-7">{actions}</div> : null}
        </div>
      </div>
    </section>
  );
}